import {
  GlobalAction,
  GlobalActions,
  GlobalPut,
  HTTP_METHOD,
  ProduktRequested,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, cancel, put, takeEvery } from 'redux-saga/effects';
import { DiagnosenModel } from '@ps20/bff-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { CheckoutActions } from '../checkout.actions';

export enum DiagnoseListRequestActions {
  DIAGNOSELIST_REQUEST_SUCCESSFUL = 'DIAGNOSELIST_REQUEST_SUCCESSFUL',
  DIAGNOSELIST_REQUEST_FAILED = 'DIAGNOSELIST_REQUEST_FAILED',
}

export const URL_DIAGNOSELIST = '/privatschutz/api/diagnose';

export function* watchDiagnoseListRequest(): SagaIterator {
  yield takeEvery(
    GlobalActions.PRODUKT_REQUESTED,
    safeSaga(getDiagnoseListSaga, App.SHOP_CHECKOUT),
  );
  yield takeEvery(
    DiagnoseListRequestActions.DIAGNOSELIST_REQUEST_SUCCESSFUL,
    safeSaga(successCallback, App.SHOP_CHECKOUT),
  );
}

export function* getDiagnoseListSaga(action: GlobalAction<ProduktRequested>): SagaIterator {
  if (action.payload.appId !== App.TKV) {
    return yield cancel();
  }
  const globalPut = GlobalPut.getInstance();
  yield call(
    globalPut.put.bind(globalPut),
    new GlobalActions().doRequest({
      appId: App.SHOP,
      method: HTTP_METHOD.GET,
      body: '',
      url: URL_DIAGNOSELIST,
      successEvent: DiagnoseListRequestActions.DIAGNOSELIST_REQUEST_SUCCESSFUL,
      errorEvent: DiagnoseListRequestActions.DIAGNOSELIST_REQUEST_FAILED,
    }),
  );
}

export function* successCallback(successAction: AnyAction): SagaIterator {
  const list = (successAction.payload as DiagnosenModel).diagnosen;
  yield put({ type: CheckoutActions.DIAGNOSE_LIST_RECEIVED, payload: list });
}
